import * as React from 'react';

import ActionLink from 'components/buttons/action-link/ActionLink';
import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';

import { __t, applyTranslations } from 'utils/language';

import './proposal-no-results.scss';

applyTranslations(require('./proposal-no-results.i18n.json'));

type Props = {
  canReset?: boolean,
  onReset: () => void
};

const ProposalNoResults = ({
  canReset,
  onReset
}: Props) => (
  <div className="proposal-no-results">
    <div>{__t('proposal_no_results.filter_no_results_label')}</div>
    <VerticalSpacing type="small" />
    {canReset && (
      <ActionLink
        color="light"
        size="medium"
        onClick={onReset}
      >
        {__t('proposal_no_results.filter_reset_label')}
      </ActionLink>
    )}
  </div>
);

export default ProposalNoResults;
